<script lang="ts" setup>
withDefaults(defineProps<{ status?: string, size: string }>(), { size: 'xl' })
const distances = [5, 10, 25, 50, 100, undefined]
const { userLocation, selectedDistance } = useSettings()
</script>

<template>
  <div>
    <LocationFinder v-model="userLocation" placeholder="Enter your Address" :size="size" icon="ri:map-pin-add-line"
      :loading="status === 'pending'"
      :ui="{ rounded: '!rounded-r-none', base: '!ring-slate-200 !ring-2 hover:!ring-primary-500 focus:!ring-primary-500  !ring-offset-2 focus:!ring-offset-2 !ring-inset', trailing: { padding: { xl: userLocation ? 'pe-10' : 'pe-2' } } }" />
    <UPopover>
      <UButton icon="ri:pin-distance-fill" aria-label="Distance" color="gray" :size="size"
        :ui="{ rounded: 'rounded-l-none', base: '!pt-2.5 !ring-transparent hover:!ring-primary-500 focus-within:!ring-primary-500 !ring-2' }" />
      <template #panel>
        <div class="flex flex-col ">
          <button v-for="distance in distances" :key="distance"
            class="text-left hover:bg-slate-100 px-2 md:px-3 lg:px-4 py-2 "
            :class="{ 'bg-primary-100/50 font-bold': distance === selectedDistance }"
            @click="selectedDistance = distance">
            <template v-if="distance">
              Within {{ distance }} miles
            </template>
            <template v-else>
              All Locations
            </template>
          </button>
        </div>
      </template>
    </UPopover>
  </div>
</template>
